export const type = [
  { label: 'Text(short)', value: 'Text(short)' },
  { label: 'Text(long)', value: 'Text(long)' },
  { label: 'Number', value: 'Number' },
  { label: 'Currency', value: 'Currency' },
  { label: 'Boolean', value: 'Boolean' },
  { label: 'List', value: 'List' },
  { label: 'Date', value: 'Date' },
  { label: 'Date without timezone', value: 'DOB' },
];
export const appliesTo = [
  {
    label: 'Both Time Entries & Expenses',
    value: 'Both Time Entries & Expenses',
  },
  { label: 'Time Entries Only', value: 'Time Entries Only' },
  { label: 'Expenses Only', value: 'Expenses Only' },
];

export const customFieldCategories = [
  { label: 'Cases', value: 'case' },
  { label: 'Contacts', value: 'contact' },
  { label: 'Companies', value: 'companies' },
  // { label: "Time & Expenses", value: "time&expenses" },
];

export const getCustomFieldTitle = (category) => {
  let title = '';
  switch (category) {
    case 'case':
      title = 'Cases';
      break;
    case 'contact':
      title = 'Contacts';
      break;
    case 'companies':
      title = 'Companies';
      break;
    case 'time&expenses':
      title = 'Time & Expenses';
      break;
    default:
  }
  return title;
};

export const getTabValue = (module) => {
  let tabValue = 0;
  switch (module) {
    case 'case':
      tabValue = 0;
      break;
    case 'contact':
      tabValue = 1;
      break;
    case 'companies':
      tabValue = 2;
      break;

    default:
  }
  return tabValue;
};

export const customHeaderTemplate = (data) => {
  return (
    <div>
      <div className="d-flex">
        <div>
          <i className="icon-window-filled modal-close-icon pointer F-size14" onClick={data?.onHide}></i>
          {/* <i className="icon-window-filled pointer F-size14 icon-minimize"></i> */}
        </div>
      </div>
    </div>
  );
};
export const customFooter = () => {
  return <div></div>;
};

export const getModuleNameFromActiveIndex = (activeIndex) => {
  if (activeIndex === 0) {
    return 'case';
  } else if (activeIndex === 1) {
    return 'contact';
  }
  if (activeIndex === 2) {
    return 'companies';
  }
};
